import { render, staticRenderFns } from "./TemplateRefEditor.vue?vue&type=template&id=31747eb5&"
import script from "./TemplateRefEditor.vue?vue&type=script&lang=js&"
export * from "./TemplateRefEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports